export default __webpack_public_path__ + "static/media/contact.0d61a84a.png";